import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { resetState } from '../components/Login/actions/login';
import { authProvider } from '../components/Login/auth/auth_provider';
import { persistor } from '../store/Store';

const DEFAULT_IDLE_TIMEOUT_MINUTES = 60;
const parsedMinutes = Number(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES);
const IDLE_TIMEOUT_MINUTES = parsedMinutes > 0 ? parsedMinutes : DEFAULT_IDLE_TIMEOUT_MINUTES;
export const IDLE_TIMEOUT_MS = IDLE_TIMEOUT_MINUTES * 60 * 1000;

const ACTIVITY_EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'wheel'];

// Cierra la sesion por inactividad. Misma secuencia que el logout manual del
// Topbar: persistir el reset ANTES de navegar al logout de B2C, porque la
// escritura de redux-persist es asincrona y una navegacion la interrumpe.
const useIdleLogout = (isActive) => {
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    const handleIdleLogout = () => {
      dispatch(resetState());
      persistor.flush().finally(() => authProvider.logout());
    };

    const resetTimer = () => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(handleIdleLogout, IDLE_TIMEOUT_MS);
    };

    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(timerRef.current);
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [isActive, dispatch]);
};

export default useIdleLogout;
